import {
  appraisalConfigFields,
  getAppraisalConfig,
} from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/Appraisal/Appraisal.config';
import _ from 'lodash';

import {
  APPRAISAL_FORM_PATH,
  DEFAULT_APPRAISAL_NUMBER_OF_UNITS,
} from './LoanEditorCustomFormDrawer.constants';

export const APPRAISAL_FIELD_NAMES = new Set(
  Object.values(appraisalConfigFields)
    .filter(({ nameInModel }) => nameInModel.startsWith(`${APPRAISAL_FORM_PATH}.`))
    .map(({ fieldId }) => fieldId),
);

export const checkIsAppraisalEnabled = ({
  isProductsLoaded,
  isSelectionViewAllowed,
  hasPropertyData,
  isUnsecured,
  isChattel,
}) =>
  (!isSelectionViewAllowed || !!isProductsLoaded) &&
  !!hasPropertyData &&
  !isUnsecured &&
  !isChattel;

const checkIsAppraisalAvailable = appraisalContext => !!appraisalContext?.isEnabled;

const getAppraisalGroups = appraisalContext =>
  getAppraisalConfig({
    numberOfUnits: Number(appraisalContext.numberOfUnits ?? DEFAULT_APPRAISAL_NUMBER_OF_UNITS),
    loanType: appraisalContext.loanType,
    isLoanTBDBundleIssued: appraisalContext.isLoanTBDBundleIssued,
    appraisalProductOptions: appraisalContext.appraisalProductOptions,
    isAppraisalSelectionViewAllowed: appraisalContext.isViewAllowed,
    isAppraisalSelectionEditAllowed: appraisalContext.isEditAllowed,
  }).groups;

export const getAppraisalSeedFields = ({ appraisalContext }) =>
  checkIsAppraisalAvailable(appraisalContext) ? getAppraisalGroups(appraisalContext) : [];

export const getAppraisalConfigFieldsForContext = appraisalContext => {
  if (!checkIsAppraisalAvailable(appraisalContext)) {
    return {};
  }

  return _.keyBy(
    getAppraisalGroups(appraisalContext)
      .flatMap(group => group.fields)
      .filter(field => APPRAISAL_FIELD_NAMES.has(field.fieldId)),
    'fieldId',
  );
};
